module.exports = __webpack_public_path__ + "static/media/kids_24.496883d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_24.jpg
// module id = 5880
// module chunks = 0